<template>
    <div
        class="upload-container"
        :class="{ 'is-dragger': isDragOver }"
        @dragover.prevent="handleDragOver"
        @dragleave.prevent="handleDragLeave"
        @drop.prevent="dropUpload"
    >
        <input type="file" ref="fileRef" id="file-ref" @change="uploadFile" :accept="accept" />
        <div class="target-content">
            <div class="target" @click="handleUpload">
                <slot name="target"></slot>
            </div>
        </div>
        <slot name="progress">
            <div
                class="upload-progress"
                :style="{ width: progress * 100 + '%' }"
                v-if="progress !== 1"
            ></div>
        </slot>
        <slot name="extend" v-if="progress > 0 && progress !== 1"></slot>
        <slot name="other"></slot>
    </div>
</template>

<script>
import { Message } from 'element-ui'
import { uploadFileFn, cancelUpload } from './useOss'
import { fileExt, getImageWH } from './tool'

export default {
    name: 'UploadFileWidget',
    props: {
        field: { type: String, default: '' },
        limitSize: { type: Number, default: 1024 * 1024 * 2 },
        accept: { type: String, default: '.jpg,.png,.jpeg,.gif,.webp' },
        action: { type: String, default: '' },
        width: { type: Number, default: 0 },
        height: { type: Number, default: 0 },
        isDraggable: { type: Boolean, default: false },
        isPublic: { type: Boolean, default: true },
        beforeUpload: { type: Function }
    },
    data() {
        return {
            progress: 0,
            isDragOver: false,
            abortCheckpoint: null,
            client: null,
            disabled: false,
        }
    },
    mounted() {},
    methods: {
        handleUpload() {
            if (this.disabled) return Message.warning("等待文件上传完成") 
            this.$refs.fileRef.click()
        },
        async handleUploadFile(file) {
            if (this.beforeUpload) {
                try {
                    const res = await this.beforeUpload(file)
                    if (res === false) return
                } catch (e) {
                    console.error('err', e)
                    return
                }
            }

            const ext = fileExt(file)
            if (this.accept !== '*/*' && !this.accept.split(',').includes('.' + ext)) {
                Message.warning('文件格式不支持，文件格式支持：' + this.accept)
                return
            }
            if (file.size > this.limitSize) {
                Message.warning('文件太大,请上传不超过' + this.limitSize / (1024 * 1024) + 'M')
                return
            }

            if (this.width && this.height && file.type.startsWith('image/')) {
                try {
                    const { width, height } = await getImageWH(file)
                    if (width !== this.width && height !== this.height) {
                        Message.warning(
                            `上传的图片分辨率不符合，请上传分辨率为：${this.width}px${this.height}px的图片`
                        )
                        return
                    }
                } catch (e) {
                    Message.error('图片加载异常请重新上传')
                }
            }
            this.disabled = true
            const result = await uploadFileFn(
                file,
                (percent, cpt, _client) => {
                    this.progress = percent
                    this.$emit('progress', percent)
                    this.client = _client
                    this.abortCheckpoint = cpt
                },
                this.isPublic
            )
            this.disabled = false
            if (result !== false) {
                this.$emit('success', result)
                Message.success('上传成功')
            }
        },
        async uploadFile() {
            const file = this.$refs.fileRef.files[0]
            if (this.$refs.fileRef) {
                this.$refs.fileRef.value = ''
            }
            if (file) {
                await this.handleUploadFile(file)
            }
        },
        async cancelUpload2Oss() {
            await cancelUpload(this.abortCheckpoint, this.client)
        },
        handleDragOver() {
            if (this.isDraggable) {
                this.isDragOver = true
            }
        },
        handleDragLeave() {
            if (this.isDraggable) {
                this.isDragOver = false
            }
        },
        dropUpload(evt) {
            if (!this.isDraggable) return
            this.isDragOver = false
            const files = evt.dataTransfer?.files
            if (files && files.length > 0) {
                this.handleUploadFile(files[0])
                if (this.$refs.fileRef) {
                    this.$refs.fileRef.value = ''
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
$__bar-height: 3px;
.target-content {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}
.is-dragger {
    background-color: #edf4ff;
    border: 2px dashed #0a84ff;
    border-radius: 8px;
}
#file-ref {
    display: none;
}
.upload-container {
    width: 100%;
    height: 100%;
    position: relative;
    .upload-progress {
        position: absolute;
        left: 0;
        bottom: -$__bar-height;
        height: $__bar-height;
        width: 100%;
        border-radius: calc($__bar-height / 2);
        background-color: #67c23a;
    }
}
</style>
